import formatter from '@/helpers/formatter'

export default {
  data: () => ({
      loading: false,
      valid: true,
      labels: {},
      form: {},
      rules: {},
      errors: {}
  }),

  created() {
      // this.rules.required = (field) => ((v) => !!v || formatter.titlecase(`${field} is required`))
      this.rules.required = (field) => value => !!value || this.$t('required', { field: this.$t(field)});
      this.rules.max_length = (field, length) => value => value.length <= length || this.$t('max_length', { field: this.$t(field), length: length});
      this.rules.number = value => value.match("^[0-9]*$") || this.$t('number_only');
  },

  methods: {
    handleErrors(errors) {
        if (errors) {
            this.setErrors(errors)
        }
        else {
            this.clearErrors()
        }
    },

    setErrors(errors) {
      for (let key in this.errors) {
          this.errors[key] = errors[key] || []
      }
    },

    clearErrors(key = false) {
      if (key) {
          if (this.errors[key].length) {
              this.errors[key] = []
          }
      }
      else {
          for (let key in this.errors) {
              this.errors[key] = []
          }
      }
    }
  }
}
